import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ConfirmDialogComponent } from '~/app/core/components/confirm-dialog/confirm-dialog.component';
import { UxService } from '~/app/core/services';
import { Calendar, Category } from '~/app/open-age/welcome/models/calendar.model';
import { User } from '~/app/open-age/welcome/models/user.model';
import { CalendarService } from '~/app/open-age/welcome/services/calendar.service';
import { CategoriesService } from '~/app/open-age/welcome/services/categories.service';

@Component({
  selector: 'welcome-edit-attandance',
  templateUrl: './edit-attandance.component.html',
  styleUrls: ['./edit-attandance.component.css']
})
export class EditAttandanceDialogComponent implements OnInit {

  visitor: {
    user: User,
    meta?: any,
    appointmentId?: String,
    scheduledBy?: User,
    dateCreated?: Date
    attandance?: {
      updated?: Boolean,
      firstStart?: Date,
      lastStart?: Date,
      lastEnd?: Date,
      duration?: Number,
      isPresent?: Boolean,
      status: String
    }
  };

  oldStatus: String

  constructor(
    public dialogRef: MatDialogRef<EditAttandanceDialogComponent>,
    private catgoryApi: CategoriesService,
    private calendarApi: CalendarService,
    private errorHandler: UxService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.oldStatus = this.visitor.attandance.status
  }

  save() {
    if (this.oldStatus == this.visitor.attandance.status) {
      this.dialogRef.close(false)
    } else {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '450px',
      });
      dialogRef.componentInstance.message = `You are marking ${this.visitor.user.profile.firstName} ${this.visitor.user.profile.lastName} as ${this.visitor.attandance.status}`
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.visitor.attandance.updated = true
          this.dialogRef.close(this.visitor)
        }
      })
    }
  }

}
